import React, { useEffect, useState } from "react";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import useRequest from "../../hooks/useRequest";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import {
  downloadExcel1,
  getPermissionDetails,
  stringLimit,
  stringLimit1,
} from "../../util/fn";
import Pagination from "../Pagination/Pagination";
import Select from "react-select";
import { Table, OverlayTrigger, Tooltip } from "react-bootstrap";

import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useSelector } from "react-redux";
import { BASEURL } from "../../constant/api";
import axios from "axios";

const GuestFeedback = (props) => {
  const { request: requestCities, response: responseCities } = useRequest();
  const { request: request1, response: response1 } = useRequest();

  const { request: request, response: response } = useRequest();
  const { request: requestDelete, response: responseDelete } = useRequest();
  const [permission, setPermissions] = useState();
  const { permissions } = useSelector((state) => state.auth);
  const location = useLocation();
  const [cities, setCities] = useState([]);
  const [cityId, setCityId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([
    { title: "S.No." },
    { title: "Guest Name" },
    { title: "FeedBack" },
    { title: "Order Id" },
    { title: "Outlet Name" },
    { title: "Review Star" },
  ]);

  const perPage = 10;
  const [outletId, setOutletId] = useState("");
  const [totalDocuments, setTotalDocuments] = useState(0);
  const [outletList, setOutletList] = useState([]);
  const [page, setPage] = useState(1);

  const [startIndex, setStartIndex] = useState(1);

  useEffect(() => {
    document.title = "Guest Feedbacks - Sportyfy";
    requestCities("GET", `admin/vendor/getCity`);
  }, []);

  useEffect(() => {
    request1("GET", `admin/vendor/outletByCity?cityId=${cityId}`);
    setOutletId("");
  }, [cityId]);

  useEffect(() => {
    if (responseCities) {
      if (responseCities.status && responseCities.data) {
        setCities(responseCities.data);
      }
    }
  }, [responseCities]);

  useEffect(() => {
    if (response1) {
      if (response1.status) {
        setOutletList(response1.data);
      }
    }
  }, [response1]);
  useEffect(() => {
    if (startDate || endDate) {
      request(
        "POST",
        `admin/feedback/getGuestFeedback?page=${page}&city=${cityId}&startDate=${startDate}&endDate=${endDate}&outletId=${outletId}&per_page=${10}`
      );
    }
  }, [startDate, endDate,outletId]);

  useEffect(() => {
    if (response) {
      if (response.status) {
        // if(response.data && response.data.length>0){
        setData(response.data);
        setTotalDocuments(response.totalDocument);
        // }
      }
    }       
  }, [response]);

  const fetchMoreData = ({ selected }) => {
    setPage(selected + 1);
    if (selected + 1 == 1) {
      setStartIndex(1);
    } else {
      setStartIndex(selected * perPage + 1);
    }

    request(
      "POST",
      `admin/feedback/getGuestFeedback?city=${cityId}&startDate=${startDate}&endDate=${endDate}&outletId=${outletId}&page=${
        selected + 1
      }&per_page=${10}`
    );
  };

  const renderTooltip = (props, content) => (
    <Tooltip id="button-tooltip" {...props}>
      <div dangerouslySetInnerHTML={{ __html: content }}></div>
    </Tooltip>
  );
  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb
            title={"Guests Feedback"}
            links={[{ to: "/", name: "Home" }]}
          />
          <div className="ms-panel">
            <div className="ms-panel-header">
              <div className="row">
                <div className="col-md-3">
                  <h6>{"Guests Feedback"}</h6>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label htmlFor="cities">City:</label>
                    <Select
                      options={
                        cities &&
                        cities.length > 0 &&
                        cities.map((obj) => ({
                          label: obj.name,
                          value: obj._id,
                        }))
                      }
                      name="cities"
                      onChange={(value) => {
                        setCityId(value.value);
                        request(
                          "POST",
                          `admin/feedback/getGuestFeedback?city=${value?.value}&startDate=${startDate}&endDate=${endDate}&outletId=${outletId}&page=${page}`
                        );
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label htmlFor="cities">Outlet:</label>
                    <select
                      className="form-control"
                      value={outletId}
                      onChange={(e) => {
                        setOutletId(e.target.value);
                         request(
                          "POST",
                          `admin/feedback/getGuestFeedback?city=${cityId}&startDate=${startDate}&endDate=${endDate}&outletId=${e.target.value}&page=${page}`
                        );
                      }}
                    >
                      <option value={""}>--Select outlet--</option>
                      {outletList &&
                        outletList?.map((val, i) => (
                          <option value={val._id}>{val.name}</option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label htmlFor="search">From Date:</label>
                    <input
                      type="date"
                      value={startDate}
                      className="form-control"
                      onChange={(e) => {
                        setStartDate(e.target.value);
                      }}
                    />
                  </div>
                </div>{" "}
                <div className="col-md-2">
                  <div className="form-group">
                    <label htmlFor="search">End Date:</label>
                    <input
                      type="date"
                      value={endDate}
                      className="form-control"
                      onChange={(e) => {
                        setEndDate(e.target.value);
                      }}
                    />
                  </div>
                </div>{" "}
              </div>
            </div>
            <div className="ms-panel-body">
              <div className="table-responsive">
                <table className="table table-hover thead-primary">
                  <thead>
                    <tr>
                      {columns &&
                        columns.length > 0 &&
                        columns.map((obj) => <th scope="col">{obj?.title}</th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {data &&
                      data.length > 0 &&
                      data.map((item, i) => (
                        <tr key={item.id}>
                          <th scope="row">{i + startIndex}</th>
                          <td>{item.guestName}</td>
                          <td>
                            <OverlayTrigger
                              placement="top"
                              overlay={renderTooltip({}, item.feedback)}
                            >
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: item?.feedback
                                    ? stringLimit1(item?.feedback)
                                    : "",
                                }}
                              ></span>
                            </OverlayTrigger>
                          </td>

                          <td>{item.orderId}</td>
                          <td>{item.outletName}</td>
                          <td>{item.reviewStar}</td>
                        </tr>
                      ))}
                    {data.length == 0 && (
                      <tr>
                        <td colspan="10" style={{ textAlign: "center" }}>
                          {" "}
                          No Data has found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          {
           
              <Pagination
                page={page}
                totalDocuments={totalDocuments}
                getNewData={fetchMoreData}
                perPage={perPage}
                currentDocLength={data.length}
              />
            }
        </div>
      </div>
    </div>
  );
};

export default GuestFeedback;
